module.exports = __webpack_public_path__ + "7fb1149b94222c78a571a1c11f50c3bb.glb";